import React, { useEffect, useState } from "react";
import { Tag } from "primereact/tag";
import styles from "../my-calendar.module.scss";
import PropTypes from "prop-types";
import EventDetail from "./EventDetail";
import { Tooltip } from "primereact/tooltip";
import { Badge } from "primereact/badge";
import { InputText } from "primereact/inputtext";
import useDateTime from "~/hooks/useDateTime";
import { useDispatch, useSelector } from "react-redux";
import CustomeButton from "~/components/Button";
import { toZonedTime } from "date-fns-tz";
import { getLspDetails } from "~/Pages/Lsp/actions/lspSlice";
import { getEntityAcess } from "~/components/settings/users/invite-modal/InviteModalSlice";
import { Skeleton } from "primereact/skeleton";
import Timelines from "~/components/Timeline";
import StatusBadge from "~/Pages/Process/components/StatusBadge";
import { format, parse } from "date-fns";
import apiService from "~/services/service";
import API_ROUTES from "~/api-routes";
import { CURRENT_ENVIRONMENT } from "~/config/env";

const EventDetailCalenderPayrollPlus = ({
  eventDetail,
  handleCloseEventDetailCalander,
  backBtn,
  handleViewMoreEvent,
  closeEventBtn = true,
  entityId,
}) => {
  const { formatDateTime } = useDateTime();
  const dispatch = useDispatch();
  const [payslipUrl, setPayslipUrl] = useState(null);
  const [deadlineTime, setDeadlineTime] = useState(null);
  const { timezone, id: userId, role } = useSelector((state) => state.login);
  const { lspdetails } = useSelector((state) => state.lsponboarding);
  const { service_url_override: userServiceUrlOverride } = useSelector(
    (state) => state.inviteusers,
  );
  const { payslip_portal_link: userPayslipPortalLink } = useSelector(
    (state) => state.inviteusers,
  );

  const viewProcessHandler = () => {
    window.open(
      window.location.origin +
        "/process/" +
        eventDetail?.process +
        "/milestones",
    );
  };

  useEffect(() => {
    console.log("EventDetailCalenderPayrollPlus - eventDetail:", eventDetail);
    console.log(
      "EventDetailCalenderPayrollPlus - eventDetail?.entity:",
      eventDetail?.entity,
    );
    console.log(
      "EventDetailCalenderPayrollPlus - eventDetail?.entityData:",
      eventDetail?.entityData,
    );
  }, [eventDetail]);

  const viewPayslip = () => {
    window.open(payslipUrl);
  };

  const getDateInEntityTimezone = (date) => {
    if (!date || !eventDetail?.entityData?.timezone) {
      setDeadlineTime(null);
      return;
    }
    const utcDate = new Date(date);
    if (isNaN(utcDate.getTime())) {
      setDeadlineTime(null);
      return;
    }
    const timeZone = eventDetail?.entityData?.timezone;
    const zonedDate = toZonedTime(utcDate, timeZone);
    setDeadlineTime(zonedDate);
  };

  useEffect(() => {
    getDateInEntityTimezone(eventDetail?.due_date_utc);
  }, [eventDetail?.entityData]);

  // GXM-1744: Fetch user's entity access to get service_url_override for LSP users
  useEffect(() => {
    const LSP_ROLES = ["LSP_USER", "LSP_MANAGER"];
    if (LSP_ROLES.includes(role) && userId) {
      dispatch(getEntityAcess(userId));
    }
  }, [role, userId, dispatch]);

  // GXM-1744: Resolve payslip URL based on user role
  // LSP users: use their own tenant's service_url_override (from inviteusers slice)
  // Customer users: use their tenant's service_url_override (TODO: needs backend support)
  // GXM users: use generic payslip URL
  const resolvePayslipUrl = () => {
    const CUSTOMER_ROLES = ["CUSTOMER", "CUSTOMER_MANAGER"];
    const GXM_ROLES = ["GXM_USER", "GXM_MANAGER", "GXM_ADMIN"];
    const LSP_ROLES = ["LSP_USER", "LSP_MANAGER"];
    let payslipURL;
    if (CURRENT_ENVIRONMENT === "STAG" || CURRENT_ENVIRONMENT === "DEV") {
      payslipURL = "https://hsp.pay-preprod.com/dashboard/";
    } else {
      payslipURL = "https://hsp.payslip.com";
    }
    // GXM users get generic URL
    if (GXM_ROLES.includes(role)) {
      setPayslipUrl(payslipURL);
      return;
    }

    // LSP users: use their own tenant's service_url_override
    if (LSP_ROLES.includes(role)) {
      payslipURL =
        eventDetail?.processData?.entityData?.tenantData?.payslip_portal_link;
      setPayslipUrl(userPayslipPortalLink);
      return;
    }

    // Customer users: use generic payslip URL
    // Note: Could use service's payslip_url if available from eventDetail
    if (CUSTOMER_ROLES.includes(role)) {
      setPayslipUrl(payslipURL);
      return;
    }
  };

  useEffect(() => {
    resolvePayslipUrl();
  }, [userServiceUrlOverride, lspdetails, role]);

  const formatDateRange = (dateRangeStr) => {
    if (!dateRangeStr) return "";

    const [startStr, endStr] = dateRangeStr.split("-");

    const startDate = parse(startStr, "dd/MM/yyyy", new Date());
    const endDate = parse(endStr, "dd/MM/yyyy", new Date());

    const formattedStart = format(startDate, "MMMM do, yyyy");
    const formattedEnd = format(endDate, "MMMM do, yyyy");

    return `${formattedStart} - ${formattedEnd}`;
  };

  return (
    <div className={styles["event-detail-container"]}>
      <div className={styles["event-header-container"]}>
        <div className="flex align-items-center">
          {backBtn && (
            <span className={styles["back"]}>
              <i className="pi pi-arrow-left" onClick={handleViewMoreEvent}></i>
            </span>
          )}
          <div className={styles["event-header"]}>
            <h2 className={styles["event-header-title"]}>
              {eventDetail?.title}
            </h2>
          </div>
        </div>
        {closeEventBtn && (
          <span className={styles["close__calander"]}>
            <i
              className="pi pi-times"
              onClick={handleCloseEventDetailCalander}
            ></i>
          </span>
        )}
      </div>
      <div className={styles["sidenav-process"]}>
        <div className="w-full">
          <div className="sidebar-milestones-container">
            <div className={styles["details"]}>
              <p className={styles["sidebar-details-label"]}>Details</p>
              <div className={styles["field"]}>
                <label className="input-label">Status</label>
                <div className="p-inputtext w-full request__calander__input flex align-items-center">
                  <Badge
                    style={{
                      backgroundColor: eventDetail?.status?.primary_color,
                    }}
                    className="opacity-60"
                  />
                  <span className="opacity-60">
                    {eventDetail?.status?.name}
                  </span>
                </div>

                <span
                  className={styles["sidenav-input-icon-date"]}
                  data-testid="sidenav-input-icon"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>
              <div className={styles["field"]}>
                <label className="input-label">Due Date</label>
                <InputText
                  value={formatDateTime({
                    date: deadlineTime,
                    dateformat: "MMMM do, yyyy",
                  })}
                  readOnly
                  className="w-full request__calander__input"
                  placeholder="Select date"
                  disabled
                />
                <span
                  className={styles["sidenav-input-icon-date"]}
                  data-testid="sidenav-input-icon"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>
              <div className={styles["field"]}>
                <label className="input-label">Service Line</label>
                <InputText
                  value={"Payroll Plus"}
                  placeholder="Select Service Line"
                  name="email"
                  className="appearance-none outline-none w-full "
                  disabled
                />
                <span
                  className={styles["sidenav-input-icon-lock"]}
                  data-testid="sidenav-input-icon-lock"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>
              <div className={styles["field"]}>
                <label className="input-label">Process Name</label>
                <InputText
                  value={eventDetail?.title}
                  placeholder="Select Process Name"
                  name="process"
                  className={`appearance-none outline-none w-full ${styles["truncate-value"]}`}
                  disabled
                />
                <span
                  className={styles["sidenav-input-icon-lock"]}
                  data-testid="sidenav-input-icon-lock"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>

              <div className={styles["field"]}>
                <label className="input-label">Period</label>
                <InputText
                  value={formatDateRange(eventDetail?.processData?.payrun)}
                  placeholder="Select Process Name"
                  name="process"
                  className={`appearance-none outline-none w-full ${styles["truncate-value"]}`}
                  disabled
                />
                <span
                  className={styles["sidenav-input-icon-lock"]}
                  data-testid="sidenav-input-icon-lock"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>
              <div className={styles["action-buttons"]}>
                <CustomeButton
                  label="Open Process"
                  variant="contained"
                  onClick={viewProcessHandler}
                />
              </div>
              <div className={styles["action-buttons"]}>
                <CustomeButton
                  label="Open Payslip"
                  onClick={viewPayslip}
                  icon="pi pi-external-link"
                  iconPos="right"
                  disabled={!payslipUrl}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
EventDetailCalenderPayrollPlus.propTypes = {
  eventDetail: PropTypes.object,
  handleCloseEventDetailCalander: PropTypes.func,
  backBtn: PropTypes.bool,
  handleViewMoreEvent: PropTypes.func,
  closeEventBtn: PropTypes.bool,
  entityId: PropTypes.string,
};

export default EventDetailCalenderPayrollPlus;
